import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  Page,
  Card,
  Text,
  PageActions,
  TextField,
  FormLayout,
  Select,
  Loading,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import TagsInput from "react-tagsinput";
import { validate } from "email-validator";
import { useParams } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";

export const EditContact = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(true);
  const [firstNameValue, setFirstNameValue] = useState("");
  const handleChangeFirstName = (newValue) => {
    setItem({ ...item, firstName: newValue });
    setFnError("");
  };

  const [lastNameValue, setLastNameValue] = useState("");
  const handleChangeLastName = (newValue) => {
    setItem({ ...item, lastName: newValue });
    setLnError("");
  };
  const [emailValue, setEmailValue] = useState("");
  const handleChangeEmail = (newValue) => {
    setItem({ ...item, email: newValue });
    setEmailError("");
  };

  const [addressValue, setAddressValue] = useState("");
  const handleChangeAddress = (newValue) => {
    setItem({ ...item, address: newValue });
  };
  const handleChangePhone = (newValue) => {
    setItem({ ...item, phone: newValue });
  };
  const handleChangeExternalCampaign = (newValue) => {
    setItem({ ...item, externalCampaign: newValue });
  };
  const handleChangeForecast = (newValue) => {
    setItem({ ...item, forecast: newValue });
  };
  const [tags, setTags] = useState([]);
  const handleChangeTags = (newValue) => {
    setItem({ ...item, tags: newValue });
  };
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const handleSelectChangeCategory = (newValue) => {
    setItem({ ...item, category: newValue });
    setCategoryError("");
  };
  const [admins, setAdmins] = useState([]);
  const handleSelectChangeAdmin = (newValue) => {
    setItem({ ...item, admin: newValue });
  };
  const [languages, setLanguages] = useState([]);
  const handleSelectChangeLanguage = (newValue) => {
    setItem({ ...item, language: newValue });
  };
  const [statuses, setStatuses] = useState([]);
  const handleSelectChangeStatus = (newValue) => {
    setItem({ ...item, status: newValue });
  };

  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const handleSelectChangeCampaign = (newValue) => {
    setItem({ ...item, campaign: newValue });
    setCampaignError("");
  };

  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const handleSelectChangeCompany = (newValue) => {
    setItem({ ...item, company: newValue });
    setCompanyError("");
  };
  const [fnError, setFnError] = useState("");
  const [lnError, setLnError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [campaignError, setCampaignError] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [selectedMedium, setSelectedMedium] = useState("");
  const handleSelectChangeMedium = (newValue) => {
    setItem({ ...item, medium: newValue });
  };
  const optionsMedium = [
    { label: "Phone", value: "1" },
    { label: "Email", value: "2" },
    { label: "Meeting", value: "3" },
  ];
  const [item, setItem] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    tags: "",
    category: "",
    status: "",
    campaign: "",
    company: "",
    admin: "",
    phone: "",
    externalCampaign: "",
    forecast: "",
    language: "",
    medium: "",
  });
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseCategories = "";
    let responseStatuses = "";
    let responseCampaigns = "";
    let responseCompanies = "";
    let responseContact = "";
    let responseAdmins = "";
    let responseLanguages = "";
    try {
      responseCategories = await axios.get(`/crm/categories`);
      responseCategories?.data?.data?.data &&
        setCategories(
          responseCategories?.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseStatuses = await axios.get(`/crm/statuses`);
      responseStatuses?.data?.data?.data &&
        setStatuses(
          responseStatuses.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseCampaigns = await axios.get(`/crm/campaigns`);
      responseCampaigns?.data?.data?.data &&
        setCampaigns(
          responseCampaigns.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseCompanies = await axios.get(`/crm/companies`);
      responseCompanies?.data?.data?.data &&
        setCompanies(
          responseCompanies.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseLanguages = await axios.get(`/settings/languages`);
      responseLanguages?.data?.data?.data &&
        setLanguages(
          responseLanguages.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseAdmins = await axios.get(`/management/users`);
      responseAdmins?.data?.data?.data &&
        setAdmins(
          responseAdmins?.data?.data?.data.map((item, index) => {
            return {
              label: item?.first_name
                ? item?.first_name
                : "" + item?.last_name
                ? item?.last_name
                : "",
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseContact = await axios.get(`/crm/contacts/${id}`);
      setItem({
        firstName: responseContact?.data?.data?.first_name
          ? responseContact.data.data.first_name
          : "",
        lastName: responseContact?.data?.data?.last_name
          ? responseContact.data.data.last_name
          : "",
        email: responseContact?.data?.data?.email
          ? responseContact.data.data.email
          : "",
        address: responseContact?.data?.data?.address
          ? responseContact.data.data.address
          : "",
        phone: responseContact?.data?.data?.phone
          ? responseContact.data.data.phone
          : "",
        externalCampaign: responseContact?.data?.data?.external_campaign
          ? responseContact.data.data.external_campaign
          : "",
        medium:
          responseContact?.data?.data?.medium &&
          responseContact?.data?.data?.medium?.id !== null
            ? String(responseContact.data.data.medium.id)
            : "",
        tags: responseContact?.data?.data?.tags
          ? responseContact.data.data.tags
          : "",
        category:
          responseContact?.data?.data?.category_id !== null
            ? String(responseContact.data.data.category_id)
            : "",
        language:
          responseContact?.data?.data?.language_id !== null
            ? String(responseContact.data.data.language_id)
            : "",
        status:
          responseContact?.data?.data?.status_id !== null
            ? String(responseContact.data.data.status_id)
            : "",
        forecast:
          responseContact?.data?.data?.forecast !== null
            ? String(responseContact.data.data.forecast)
            : "",
        company:
          responseContact?.data?.data?.company_id !== null
            ? String(responseContact.data.data.company_id)
            : "",
        // campaign:
        //   responseContact?.data?.data?.internal_campaign_id !== null
        //     ? String(responseContact.data.data.internal_campaign_id)
        //     : "",
        admin:
          responseContact?.data?.data?.admin_id !== null
            ? String(responseContact.data.data.admin_id)
            : "",
      });
      responseContact?.data?.data?.internal_campaigns &&
        setSelectedCampaigns(
          responseContact?.data?.data?.internal_campaigns.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }

    setIsSaving(false);
  }
  return (
    <Page
      title="Edit Contact"
      narrowWidth
      breadcrumbs={[{ onAction: () => navigate(`/admin/crm/contacts`) }]}
    >
      {isSaving ? <Loading /> : null}
      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="First Name"
              value={item.firstName}
              onChange={handleChangeFirstName}
              error={fnError}
            />
            <TextField
              label="Last Name"
              value={item.lastName}
              onChange={handleChangeLastName}
              error={lnError}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="Email"
              value={item.email}
              onChange={handleChangeEmail}
              error={emailError}
            />
            <TextField
              label="Address"
              value={item.address}
              onChange={handleChangeAddress}
            />
          </FormLayout.Group>
          <TextField
            label="Phone"
            value={item.phone}
            onChange={handleChangePhone}
            type="number"
          />
          <Text variant="bodyMd" as="p" fontWeight="regualr">
            Tags
          </Text>
          {item.tags && (
            <TagsInput value={item?.tags} onChange={handleChangeTags} />
          )}
          <FormLayout.Group>
            <FormLayout>
              <Select
                label="Category"
                options={categories}
                onChange={handleSelectChangeCategory}
                value={item.category}
                placeholder="Please select a category"
                error={categoryError}
              />
            </FormLayout>
            <FormLayout>
              <Select
                label="Status"
                options={statuses}
                onChange={handleSelectChangeStatus}
                value={item.status}
                placeholder="Please select a status"
              />
            </FormLayout>
          </FormLayout.Group>

          <FormLayout.Group>
            <Select
              label="Company"
              options={companies}
              onChange={handleSelectChangeCompany}
              value={item.company}
              placeholder="Please select a company"
              error={companyError}
            />
            <Select
              label="Admin"
              options={admins}
              onChange={handleSelectChangeAdmin}
              value={item.admin}
              placeholder="Please select an admin"
              // error={companyError}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="External Campaign"
              value={item.externalCampaign}
              onChange={handleChangeExternalCampaign}
            />
            <TextField
              label="Forecast"
              value={item.forecast}
              onChange={handleChangeForecast}
              type="number"
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Select
              label="Language"
              options={languages}
              onChange={handleSelectChangeLanguage}
              value={item.language}
              placeholder="Please select a language"
              // error={companyError}
            />
            <Select
              label="Medium"
              options={optionsMedium}
              onChange={handleSelectChangeMedium}
              value={item.medium}
              placeholder="Please select"
            />
          </FormLayout.Group>
          <Text variant="bodyMd" as="p" fontWeight="regualr">
            Campaigns
          </Text>
          <MultiSelect
            options={campaigns}
            value={selectedCampaigns}
            onChange={setSelectedCampaigns}
            labelledBy="Please select campaigns"
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
    </Page>
  );
  function handleSave() {
    if (
      !item.firstName ||
      !item.lastName ||
      !item.email ||
      item.campaign === "" ||
      item.company === "" ||
      item.category === "" ||
      (!validate(item.email) && item.email)
    ) {
      !item.firstName && setFnError("This field is required");
      !item.lastName && setLnError("This field is required");
      !item.email && setEmailError("This field is required");
      item.campaign === "" && setCampaignError("Please select a campaign");
      item.company === "" && setCompanyError("Please select a company");
      item.category === "" && setCategoryError("Please select a category");
      !validate(item.email) && setEmailError("Please enter a valid email");
    } else {
      setIsSaving(true);
      const bodyObj = {
        first_name: item.firstName,
        last_name: item.lastName,
        email: item.email,
        tags: item.tags,
        company_id: item.company,
        category_id: item.category,
        internal_campaigns: selectedCampaigns.map((item) => item.value),
        status_id: item.status,
        admin_id: item.admin,
        phone: item.phone,
        forecast: item.forecast,
        language_id: item.language,
        medium: item.medium,
        source: "",
        external_campaign: item.externalCampaign,
        last_contacted: "",
      };
      axios
        .patch(`/crm/contacts/${id}`, bodyObj)
        .then((res) => {
          setIsSaving(false);
          navigate("/admin/crm/contacts");
        })
        .catch((err) => console.log(""));
    }
  }
};
